import ActionsForm from '@/shared/mixins/actionsForm'
import VueHtml2pdf from 'vue-html2pdf'
import cabecalhoPng from '../../../../../../../../../static/img/realestate/relatorio/cabecalho.png'
import aprReport from '@/shared/http/repositories/business/aprReport'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  name: 'aprReportTable',
  components: {VueHtml2pdf},
  mixins: [ActionsForm],
  prop: ['formSearch'],
  data () {
    return {
      dataFormatada: null,
      filtros: {},
      formSearch: {},
      quantitativos: {},
      dados: []
    }
  },
  computed: {
    nomeArquivo () {
      return `Relatorio APR - ${this.dataFormatada}`
    }
  },
  mounted () {
    this.dataFormatadaPdf()
    this.groupedData()
    // this.GetAllRelatorioAPRPDF()
  },
  methods: {
    groupedData () {
      let chunks = []
      for (let i = 0; i < this.dados.length; i += 15) {
        chunks.push(this.dados.slice(i, i + 15))
      }
      return chunks
    },
    dataFormatadaPdf () {
      var dataAtual = new Date()
      var ano = dataAtual.getFullYear()
      var mes = ('0' + (dataAtual.getMonth() + 1)).slice(-2)
      var dia = ('0' + dataAtual.getDate()).slice(-2)
      this.dataFormatada = dia + '/' + mes + '/' + ano
    },
    createImageHeaderFooter (imgHref) {
      const img = document.createElement('img')
      img.src = imgHref
      img.style.border = 'none'
      return img
    },
    generatePDF () {
      // this.GetAllRelatorioAPRPDF()
      this.$refs.html2Pdf.generatePdf()
    },
    async abrirNovaGuia ({ html2pdf, options, pdfContent }) {
      const headerImage = new URL(cabecalhoPng, window.location.origin)
      const headerPdf = this.createImageHeaderFooter(headerImage.href)
      options.margin = [1.5, 0, 0.5, 0]
      html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages()
        for (let i = 1; i <= totalPages; i++) {
          pdf.addImage(headerPdf, 'PNG', 0, 0, 8.5, 0)
          pdf.setPage(i)
          pdf.setFillColor(28, 98, 40)
          pdf.rect(0, pdf.internal.pageSize.getHeight() - 0.4, pdf.internal.pageSize.getWidth(), 10, 'F')
          pdf.setTextColor('#fff')
          pdf.setFont('Helvetica', 'normal') // Set font to normal for the next part
          pdf.setFontSize(10)
          pdf.setFont('Helvetica', 'bold') // Set font back to bold
          pdf.text('Zopone - ', 0.3, pdf.internal.pageSize.getHeight() - 0.15)
          pdf.text(
            " Relatório das APR's " + this.dataFormatada,
            0.90,
            pdf.internal.pageSize.getHeight() - 0.15
          )
          pdf.setFont('Helvetica', 'normal') // Set font to normal for the next part
          pdf.text(
            'Pág ',
            7,
            pdf.internal.pageSize.getHeight() - 0.15
          )
          pdf.setFont('Helvetica', 'bold')
          pdf.text(
            i + ' de ' + totalPages,
            7.3,
            pdf.internal.pageSize.getHeight() - 0.15
          )
        }
      }).save()
    },
    GetAllRelatorioAPRPDF () {
      loading.push()
      aprReport.GetAllRelatorioAPRPDF(this.formSearch)
        .then((Response) => {
          loading.pop()
          this.dados = Response.data.data
          this.generatePDF()
        }).catch(Error => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/aprReport/components/aprReportTable/components/aprReportPdf/aprReportPdf.js